<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row ms-4 me-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row mb-2">
                <div class="form-group col-sm-12">
                  <ul class="navbar-nav overflow-auto flex-row gap-4">
                    <li v-for="(value, tab) in Tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap">
                      <a href="#" @click.prevent="selectTab(value)" class="nav-link tab" :class="{'active': filters.activity === value}">
                        {{ helper.trans(`aggregators.tab.${value}`) }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="row mb-2 align-items-end">
                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <input type="text" class="form-control form-control-sm" @keydown.enter="applyFilters" :placeholder="helper.trans('labels.name')" v-model="filters.query">
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <Multiselect id="name"
                               class="multiselect-sm"
                               v-model="filters.providerName"
                               :options="providerConfigs.map((item: any) => item.name)"
                               :custom-label="(opt) => `${opt}`"
                               :multiple="false"
                               select-label="Select"
                               :placeholder="helper.trans('labels.type')"
                  >
                  </Multiselect>
                </div>
                <div class="form-group col">
                  <div class="col-auto p-0 text-end">
                    <button type="button" @click.prevent="applyFilters" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="clearFilters" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body">
              <div class="">
                <div class="d-flex justify-content-end align-items-end mb-2 me-2">
                  <button type="button" @click="showEditModal()" class="btn btn-sm btn-outline-primary text-nowrap text-capitalize">{{helper.trans('button.create')}}</button>
                </div>

                <b-modal
                  :title="createModalTitle"
                  :modelValue="createModal"
                  dialog-class="modal-lg"
                  body-class="pt-0"
                  @update:modelValue="createModal = $event"
                >
                  <template #default>
                    <ProviderForm ref="createForm"></ProviderForm>
                  </template>
                  <template #footer>
                    <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                    <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                      <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                    </LoaderWrapper>
                  </template>
                </b-modal>

                <div class="overflow-auto">
                  <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                    <tbody>
                    <tr v-for="provider in providers">
                      <td style="width: 0">
                        {{ provider.id }}
                      </td>
                      <td style="width: 0">
                        <div class="d-flex flex-column" v-if="provider._trader">
                          <small class="form-switch" v-b-tooltip.hover.left :title="`${helper.trans('direction.in')}: ${helper.trans(provider._trader.isActive ? 'trader.status.active' : 'trader.status.inactive')}`">
                            <input id="traderStatus" :disabled="isTeamLead && !store.getters.hasPermission(UserPermission.MANAGE_TRADER_TRAFFIC)" @click.prevent="toggleStatus(provider._trader, !provider._trader.isActive, Direction.PAY_IN)" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch" :checked="provider._trader.isActive">
                          </small>
                          <small class="form-switch" v-b-tooltip.hover.left :title="`${helper.trans('direction.out')}: ${helper.trans(provider._trader.isPayOutActive ? 'trader.status.active' : 'trader.status.inactive')}`">
                            <input id="traderStatus" :disabled="isTeamLead && !store.getters.hasPermission(UserPermission.MANAGE_TRADER_TRAFFIC)" @click.prevent="toggleStatus(provider._trader, !provider._trader.isPayOutActive, Direction.PAY_OUT)" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch" :checked="provider._trader.isPayOutActive">
                          </small>
                        </div>
                      </td>
                      <td style="width: 0;">
                        <UserNameLabel style="flex: 0.3" v-if="provider._trader" :user="provider._trader"></UserNameLabel>
                      </td>
                      <td style="width: 0;">
                        {{ provider.sysname }} <span class="badge bg-dark">{{provider.name}}</span>
                        <i v-if="provider.webhookAuth?.isWarning"
                           class="fa fa-exclamation-triangle text-danger ms-1"
                           v-b-tooltip.hover.right
                           :title="`${helper.trans('labels.webhook_auth')}: ${helper.trans(`webhook_auth.${provider.webhookAuth.level}`)}. ${provider.webhookAuth.note}`"></i>
                      </td>
                      <td>
                        <div v-for="account in provider._traderAccounts">

                          <div class="row">
                            <div class="col-sm-12 d-flex align-items-center justify-content-between">
                              <AccountWidget :show-id="true" :account="account"></AccountWidget>
                            </div>
                          </div>

                        </div>
                      </td>
                      <td>
                        <div v-if="provider.balance">
                          {{ numberFormatter.formatMoney(provider.balance)}}
                        </div>
                        <div v-if="provider.balanceUpdatedAt">
                          <small class="subtext">{{ dateHelper.format(provider.balanceUpdatedAt)}}</small>
                        </div>

                      </td>
                      <td style="max-width: 300px; white-space: normal">
                        <span class="badge bg-primary me-1" v-if="provider.currency">{{provider.currency}}</span>
                        <span class="badge bg-primary me-1" v-if="provider.minPayInSum">
                            {{helper.trans('labels.from_limit', {sum: numberFormatter.formatMoney(provider.minPayInSum), currency: ''})}}
                        </span>
                        <span class="badge bg-primary me-1" v-if="provider.maxPayInSum">
                            {{helper.trans('labels.to_limit', {sum: numberFormatter.formatMoney(provider.maxPayInSum), currency: ''})}}
                        </span>
                        <span v-for="option in provider.allowedPaymentOptions" class="badge bg-primary me-1">
                            {{ helper.trans('payment_options.' + option) }}
                        </span>
                        <span class="badge bg-primary me-1" v-if="provider.defaultPaymentOption">
                            {{helper.trans('labels.default')}}: {{ helper.trans('payment_options.' + provider.defaultPaymentOption) }}
                        </span>
                      </td>
                      <td style="padding: 0">
                        <div style="width: 200px; height: 70px" v-if="countStatsData[provider.id]">
                          <Bar
                            :chart-options="countChartOptions"
                            :chart-data="countStatsData[provider.id]"
                          />
                        </div>
                      </td>
                      <td class="text-end">
                        <div class="btn-group" v-if="isAdmin">
                          <button type="button" @click="showEditModal(provider)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                          <button type="button" class="btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" v-bs-dropdown-fixed aria-expanded="false">
                            <span class="visually-hidden">Toggle Dropdown</span>
                          </button>
                          <ul class="dropdown-menu">
                            <li v-if="isAdmin && store.getters.hasPermission(UserPermission.BALANCE_CORRECTION)">
                              <a  class="dropdown-item" href="#" @click.prevent="openBalanceCorrection(provider)">
                                <i class="fa fa-calculator"></i> {{$t('button.balance_correction')}}
                              </a>
                            </li>
                            <li>
                              <a  class="dropdown-item" href="#" @click.prevent="$refs.providerRequestsModal.show(provider.id)">
                                <i class="fa-regular fa-comments"></i> {{$t('labels.provider_request_log')}}
                              </a>
                            </li>
                            <li v-if="isAdmin">
                              <a class="dropdown-item" href="#" @click.prevent="showProviderHistory(provider)">
                                <i class="fa fa-clock-rotate-left"></i> {{ helper.trans('labels.history') }}
                              </a>
                            </li>
                            <li>
                              <a  class="dropdown-item" href="#" @click.prevent="$refs.providerInvoiceDiffModal.show(provider)">
                                <i class="fa-regular fa-file-text"></i> {{$t('labels.provider_invoice_diff')}}
                              </a>
                            </li>
                            <li>
                              <a  class="dropdown-item" href="#" @click.prevent="$refs.providerReportCheckModal.show(provider)">
                                <i class="fa-regular fa-file-text"></i> {{$t('labels.provider_upload_report')}}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <button v-if="isOperator" type="button" @click.prevent="showProviderHistory(provider)" class="ms-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize">
                          <i class="fa fa-clock-rotate-left"></i> {{ helper.trans('labels.history') }}
                        </button>

                        <button v-if="(isAdmin) || (isOperator && !store.getters.hasPermission(UserPermission.HIDE_DEAL_RATES))" type="button" @click="showRouting(provider._trader)" class="ms-2 btn btn-sm btn-outline-dark text-nowrap text-capitalize">
                          <i class="fa fa-percent"></i> {{helper.trans('labels.percent_rates')}}
                        </button>

                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <b-pagination
                    v-if="response.totalCount > response.items.length"
                    v-model="page"
                    :total-rows="response.totalCount"
                    :per-page="response.limit"
                    :limit="20"
                    @update:modelValue="loadList()"
                    :prev-text="$t('button.back')"
                    :next-text="$t('button.next')"
                    align="start"
                    first-number
                    hide-goto-end-buttons
                    hide-ellipsis
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <BalanceCorrectionModal 
      :showModal="balanceCorrectionModal" 
      :accountId="selectedProvider?._traderAccounts?.[0]?.id" 
      :providerName="selectedProvider?.name"
      @update:showModal="balanceCorrectionModal = $event"
      @success="loadList"
    />

    <ProviderRequestsModal ref="providerRequestsModal"></ProviderRequestsModal>
    <ProviderInvoiceDiffModal ref="providerInvoiceDiffModal"></ProviderInvoiceDiffModal>
    <ProviderReportCheckModal ref="providerReportCheckModal"></ProviderReportCheckModal>

    <SettingsHistoryModal
      ref="providerHistoryModal"
      entity-type="provider"
    />

    <b-modal dialog-class="modal-xxl"
             :title="`${routingTrader?.name}`"
             :modelValue="routingTrader !== null"
             body-class="pt-0"
             @update:modelValue="$event === false && (routingTrader = null)"
    >
      <template #default>
        <TraderRewardSettingsForm ref="traderRewardSettingsForm" :trader="routingTrader"></TraderRewardSettingsForm>
      </template>
      <template #footer>
        <button type="button" v-on:click="routingTrader = null" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
        <LoaderWrapper ref="loaderRoutingRule" :zoom="0.5" v-if="isAdmin || isOperator">
          <button type="button" @click="saveRoutingRule()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>

  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {$t, helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import TrafficGroupForm from "@/components/Form/TrafficGroupForm.vue";
import ProviderDTO from "@/models/ProviderDTO";
import { Sortable } from "sortablejs-vue3";
import PaginationDTO from "@/models/PaginationDTO";
import {Dictionary} from "@/types";
import TraderDTO from "@/models/TraderDTO";
import {Direction} from "@/models/enum/Direction";
import UserNameLabel from "@/components/UserNameLabel.vue";
import AccountDTO from "@/models/AccountDTO";
import AccountWidget from "@/components/AccountWidget.vue";
import ProviderForm from "@/components/Form/ProviderForm.vue";
import ProviderFormDTO from "@/models/form/ProviderFormDTO";
import {Chart, ChartOptions, ChartTypeRegistry, TooltipModel} from "chart.js";
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, PointElement, CategoryScale, LinearScale } from 'chart.js'
import {Bar} from "vue-chartjs";
import BalanceCorrectionModal from "@/components/BalanceCorrectionModal.vue";
import {UserPermission} from "@/models/enum/UserPermission";
import ProviderRequestsModal from "@/components/ProviderRequestsModal.vue";
import ProviderInvoiceDiffModal from "@/components/ProviderInvoiceDiffModal.vue";
import ProviderReportCheckModal from "@/components/ProviderReportCheckModal.vue";
import ProviderNameConfigDTO from "@/models/ProviderNameConfigDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import Multiselect from "vue-multiselect";
import TraderRewardSettingsForm from "@/components/Form/TraderRewardSettingsForm.vue";
import SettingsHistoryModal from "@/components/SettingsHistoryModal.vue";

ChartJS.register(Title, Tooltip, Legend, BarElement, PointElement, CategoryScale, LinearScale)
ChartJS.defaults.color = "#c0ccda";

const notification = useNotification()

interface StatItemDTO {
  id: number,
  date: string,
  total: number,
  success: number
  failed: number,
  successAvgTime: number|null,
  successMaxTime: number|null,
  successMinTime: number|null,
  failedAvgTime: number|null,
  failedMaxTime: number|null,
  failedMinTime: number|null,
}

export default defineComponent({
  methods: {$t},
  components: {
    TraderRewardSettingsForm,
    SettingsHistoryModal,
    ProviderReportCheckModal,
    ProviderInvoiceDiffModal,
    ProviderRequestsModal,
    ProviderForm,
    AccountWidget,
    UserNameLabel,
    TrafficGroupForm,
    LoaderWrapper,
    CopyButton,
    BPagination,
    Sortable,
    Bar,
    BalanceCorrectionModal,
    Multiselect
  },
  setup() {
    const store = useStore()
    const refs = {
      loader: ref<InstanceType<typeof LoaderWrapper> | null>(null),
      createForm: ref<InstanceType<typeof ProviderForm> | null>(null),
      loaderCreateFrom: ref<InstanceType<typeof LoaderWrapper> | null>(null),
      providerRequestsModal: ref<InstanceType<typeof ProviderRequestsModal> | null>(null),
      providerInvoiceDiffModal: ref<InstanceType<typeof ProviderInvoiceDiffModal> | null>(null),
      providerReportCheckModal: ref<InstanceType<typeof ProviderReportCheckModal> | null>(null),
      traderRewardSettingsForm: ref<InstanceType<typeof TraderRewardSettingsForm> | null>(null),
      loaderRoutingRule: ref<InstanceType<typeof LoaderWrapper> | null>(null),
      providerHistoryModal: ref<InstanceType<typeof SettingsHistoryModal> | null>(null),
    }


    const externalTooltipHandler = (context: any) => {
      const chart = context.chart as Chart;
      const tooltip = context.tooltip;
      const index = tooltip.dataPoints?.[0]?.dataIndex;

      let tooltipEl = document.querySelector('#chartTooltip') as HTMLDivElement

      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartTooltip'
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = '1';
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all .1s ease';

        const table = document.createElement('table');
        table.style.margin = '0px';
        table.style.fontSize = '85%';
        table.style.lineHeight = '16px';

        tooltipEl.appendChild(table);
        document.body.appendChild(tooltipEl);
      }

      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = '0';
        return;
      }

      if (tooltip.body) {
        const titleLines = tooltip.title || [];

        const tableHead = document.createElement('thead');

        titleLines.forEach((title: any) => {
          const tr = document.createElement('tr');
          tr.style.borderWidth = '0';

          const th = document.createElement('th');
          th.style.borderWidth = '0';
          const text = document.createTextNode(title);

          th.appendChild(text);
          tr.appendChild(th);
          tableHead.appendChild(tr);
        });

        const tableBody = document.createElement('tbody');

        for (let i = 0; i < 2; i++) {
          const ds = chart.data.datasets[i]
          const value = ds.data[index] ?? 'n/a';

          const span = document.createElement('span');
          span.style.background = ds.backgroundColor as string;
          span.style.borderColor = ds.borderColor as string;
          span.style.borderWidth = '2px';
          span.style.marginRight = '10px';
          span.style.height = '10px';
          span.style.width = '10px';
          span.style.display = 'inline-block';

          const tr = document.createElement('tr');
          tr.style.backgroundColor = 'inherit';
          tr.style.borderWidth = '0';

          const td = document.createElement('td');
          td.style.borderWidth = '0';

          const text = document.createTextNode(`${ds.label}: ${value}`);

          td.appendChild(span);
          td.appendChild(text);
          tr.appendChild(td);
          tableBody.appendChild(tr);
        }


        for (let i = 0; i < 2; i++) {
          const avgValue = chart.data.datasets[2 + i*3].data[index] ? numberFormatter.formatNumber(chart.data.datasets[2 + i*3].data[index] as number, 1) : '-';
          const minValue = chart.data.datasets[3 + i*3].data[index] ? numberFormatter.formatNumber(chart.data.datasets[3 + i*3].data[index] as number, 1) : '-';
          const maxValue = chart.data.datasets[4 + i*3].data[index] ? numberFormatter.formatNumber(chart.data.datasets[4 + i*3].data[index] as number, 1) : '-';
          const span = document.createElement('span');
          span.style.background = chart.data.datasets[i].backgroundColor as string;
          span.style.borderColor = chart.data.datasets[i].borderColor as string;
          span.style.borderWidth = '2px';
          span.style.marginRight = '10px';
          span.style.height = '10px';
          span.style.width = '10px';
          span.style.display = 'inline-block';
          span.style.borderRadius = '100px';
          const tr = document.createElement('tr');
          tr.style.backgroundColor = 'inherit';
          tr.style.borderWidth = '0';
          const td = document.createElement('td');
          td.style.borderWidth = '0';
          const text = document.createTextNode(`Время AVG/MIN/MAX: ${avgValue}/${minValue}/${maxValue}`);
          td.appendChild(span);
          td.appendChild(text);
          tr.appendChild(td);
          tableBody.appendChild(tr);
        }

        const tableRoot = tooltipEl.querySelector('table') as HTMLTableElement;

        while (tableRoot.firstChild) {
          tableRoot.firstChild.remove();
        }

        tableRoot.appendChild(tableHead);
        tableRoot.appendChild(tableBody);
      }

      const clientRect = chart.canvas.getBoundingClientRect();
      tooltipEl.style.opacity = '1';
      tooltipEl.style.left = (clientRect.left + window.scrollX + tooltip.caretX - tooltipEl.offsetWidth/2 - 10) + 'px';
      tooltipEl.style.top = (clientRect.top + window.scrollY - 25) + 'px';
      tooltipEl.style.font = tooltip.options.bodyFont.string;
      tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
    }

    const countChartOptions: ChartOptions = {
      animation: {
        duration: 0
      },
      layout: {
        padding: 5
      },
      responsive: true,
      aspectRatio: 200/70,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false,
          position: 'nearest',
          external: externalTooltipHandler,
        }
      },
      interaction: {
        intersect: false,
        mode: 'index',
      },
      scales: {
        x: {
          display: false,
          stacked: true
        },
        y: {
          display: false,
          stacked: false,
          ticks: {
            beginAtZero: true,
          },
        }
      }
    } as ChartOptions;

    const state = reactive({
      createModalTitle: '',
      createModal: false,
      providerConfigs: [] as ProviderNameConfigDTO[],
      filters: {
        query: '',
        providerName: '',
        activity: 'active'
      } as { query: string; providerName: string; activity: string },
      providers: [] as ProviderDTO[],
      page: 1,
      routingTrader: null as TraderDTO|null,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<ProviderDTO>,
      countStatsData: {} as any,
      balanceCorrectionModal: false,
      selectedProvider: null as ProviderDTO | null
    });

    const loadList = async () => {
      refs.loader.value?.show()
      state.response.offset = state.response.limit * (state.page - 1)
      state.response = await api.call.providers.list(state.response, {
        query: state.filters.query,
        providerName: state.filters.providerName || null,
        activity: state.filters.activity
      })
      state.providers = state.response.items

      const providerStats = (await api.call.providers.stats()) as any
      state.countStatsData = {}
      for (const provider of state.providers) {
        const providerId = provider.id
        const stats = providerStats[providerId] as StatItemDTO[]|undefined
        if (!stats) {
          continue;
        }

        state.countStatsData[providerId] = {
          labels: [] as string[],
          datasets: [
            {
              label: helper.trans('labels.success'),
              backgroundColor: '#2bc568',
              borderSkipped: false,
              data: [] as Number[],
              stack: 1,
            },
            {
              label: helper.trans('labels.total'),
              backgroundColor: '#e93939',
              borderSkipped: false,
              data: [] as Number[],
              stack: 1,
            },
            {
              label: 'avg',
              borderSkipped: false,
              data: [] as Number[],
              hidden: true
            },
            {
              label: 'min',
              borderSkipped: false,
              data: [] as Number[],
              hidden: true
            },
            {
              label: 'max',
              borderSkipped: false,
              data: [] as Number[],
              hidden: true
            },
            {
              label: 'avg',
              borderSkipped: false,
              data: [] as Number[],
              hidden: true
            },
            {
              label: 'min',
              borderSkipped: false,
              data: [] as Number[],
              hidden: true
            },
            {
              label: 'max',
              borderSkipped: false,
              data: [] as Number[],
              hidden: true
            }
          ]
        }

        let labels = [];
        let total = [];
        let successAvgTime = [];
        let successMinTime = [];
        let successMaxTime = [];

        let failedAvgTime = [];
        let failedMinTime = [];
        let failedMaxTime = [];
        let success = [];
        let failed = [];

        for (const stat of stats) {
          labels.push(dateHelper.format(stat.date))
          total.push(stat.total);
          success.push(stat.success);
          failed.push(stat.failed);
          successAvgTime.push(stat.successAvgTime);
          successMinTime.push(stat.successMinTime);
          successMaxTime.push(stat.successMaxTime);
          failedAvgTime.push(stat.failedAvgTime);
          failedMinTime.push(stat.failedMinTime);
          failedMaxTime.push(stat.failedMaxTime);
        }

        state.countStatsData[providerId].labels = labels
        state.countStatsData[providerId].datasets[0].data = success
        state.countStatsData[providerId].datasets[1].data = total
        state.countStatsData[providerId].datasets[2].data = successAvgTime
        state.countStatsData[providerId].datasets[3].data = successMinTime
        state.countStatsData[providerId].datasets[4].data = successMaxTime
        state.countStatsData[providerId].datasets[5].data = failedAvgTime
        state.countStatsData[providerId].datasets[6].data = failedMinTime
        state.countStatsData[providerId].datasets[7].data = failedMaxTime

      }



      const traderIds = state.providers.map((provider) => provider.traderId);
      let traderAccountByIds = {} as Dictionary<AccountDTO>
      let traderByIds = {} as Dictionary<TraderDTO>
      if (traderIds.length > 0) {
        for (const trader of (await api.traders({limit: state.providers.length, offset: 0} as PaginationDTO, {ids: traderIds})).items) {
          traderByIds[trader.id] = trader
        }


        for (const account of (await api.traderAccounts({offset:0, limit: 1000} as PaginationDTO, {userIds: traderIds})).items) {
          traderAccountByIds[account.traderId] = account.account
        }
      }

      for (const provider of state.providers) {
        provider._trader = traderByIds[provider.traderId] ?? null
        if (!provider._traderAccounts) {
          provider._traderAccounts = []
        }
        if (traderAccountByIds[provider.traderId]) {
          provider._traderAccounts.push(traderAccountByIds[provider.traderId])
        }
      }

      refs.loader.value?.hide()
    }

    const applyFilters = async () => {
      state.page = 1
      await loadList()
    }

    const clearFilters = async () => {
      state.filters.query = ''
      state.filters.providerName = ''
      state.filters.activity = 'active'
      state.page = 1
      await loadList()
    }

    const selectTab = async (value: string) => {
      state.filters.activity = value
      state.page = 1
      await loadList()
    }

    const toggleStatus = async (trader: TraderDTO, status: boolean, direction: Direction) => {
      refs.loader.value?.show()
      try {
        const traderDTO = await api.changeTraderStatus(trader.id, status, direction)
        for (const index in state.providers) {
          if (state.providers[index].traderId === traderDTO.id) {
            state.providers[index]._trader = {...state.providers[index]._trader, ...traderDTO}
            break;
          }
        }
      } finally {
        refs.loader.value?.hide()
      }
    }

    const save = async () => {
      refs.loaderCreateFrom.value?.show()

      refs.createForm.value!.save()
        .then(() => {
          state.createModal = false;
          loadList();
        })
        .finally(() => {
          refs.loaderCreateFrom.value?.hide();
        })
    }

    const showEditModal = async (dto: ProviderDTO|null = null) => {
      if (dto) {
        state.createModalTitle = helper.trans("labels.edit_provider", {name: dto.name})
        refs.createForm.value?.setForm({
          ...dto,
          trader: dto._trader,
          minPayInAmount: dto.minPayInSum?.amount,
          maxPayInAmount: dto.maxPayInSum?.amount,
          useProviderAmount: dto.useProviderAmount,
          payoutFeeAmount: dto.payoutFeeAmount
        } as ProviderFormDTO)
      } else {
        state.createModalTitle = helper.trans("labels.create_provider")
        refs.createForm.value?.setForm({} as ProviderFormDTO)
      }

      state.createModal = true;
    }

    const openBalanceCorrection = (provider: ProviderDTO) => {
      state.selectedProvider = provider
      state.balanceCorrectionModal = true
    }

    const showRouting = (dto: TraderDTO) => {
      state.routingTrader = dto
    }

    const saveRoutingRule = async () => {
      refs.loaderRoutingRule.value?.show()

      try {
        await refs.traderRewardSettingsForm.value?.save();
        state.routingTrader = null;
      } finally {
        refs.loaderRoutingRule.value?.hide()
      }
    }

    const showProviderHistory = (provider: ProviderDTO) => {
      refs.providerHistoryModal.value?.show(
        provider.id,
        helper.trans('labels.history') + `: ${provider.name}`,
      )
    }

    onMounted(async () => {
      state.providerConfigs = await api.call.providers.configs()
      loadList()
    });

    return {
      ...toRefs(state),
      ...refs,
      store,
      dateHelper,
      numberFormatter,
      helper,
      save,
      showEditModal,
      openBalanceCorrection,
      loadList,
      applyFilters,
      clearFilters,
      selectTab,
      toggleStatus,
      Direction,
      Tabs: {
        active: 'active',
        inactive: 'inactive',
        all: 'all'
      },
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      isTeamLead: computed(() => store.getters.isTeamLead),
      countChartOptions,
      showRouting,
      saveRoutingRule,
      showProviderHistory,
      UserPermission,
    }
  }
})
</script>
